import {getConfig} from "@/api/ErpConfigApi";

/**
 * 配置model
 */
class ErpConfigModel {
  // 获取配置
  static async getConfig(key, field) {
    let [data] = await getConfig(key, field);
    return data.data;
  }
}

export {ErpConfigModel}
